import React, { useEffect } from 'react'
import { ekincare_full_logo } from '../../assets/images'
import { LeftPanel } from '../common/templates/Login';
import QRCode from '../common/templates/Login/QRCode';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { appApi } from '../../services';
import { message } from 'antd';

function QRCodePage() {
  const location = useLocation()
  const history = useHistory()

  useEffect(() => {
    let mfa_token = sessionStorage.getItem('mfa_token')
    if(!mfa_token) history.push('/login')
  },[])

  const qr = location.state?.qr_code 
  const alt_code = location.state?.alternative_code

  const requestAuth = async (code) => {
    let mfa_token = sessionStorage.getItem('mfa_token')
    let options = { data: {mfa_token: mfa_token, otp_code: code}}

    await appApi.mfaAuth(options,
      (res)=>{
          let msg = res?.data?.message
          message.success(msg)
          history.push({pathname: '/mfa-backup-code', state: res.data})
      },
      (e) => {
          let msg = e?.response?.data?.message || 'something went wrong!'
          message.error(msg)
      }
      );
  }

  return (
      <div className='flex min-h-screen'>
        <LeftPanel />
        <div className='w-2/5 pt-16 pl-24 bg-white'>
          <img src={ekincare_full_logo} alt='ekincare_logo' />
          <QRCode qr_code={qr} alt_code={alt_code} requestAuth={requestAuth} />
        </div>
      </div>
    )
}

export default QRCodePage;